import React from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons'
import Modal, { Body, Footer, Header } from 'src/components/theme/Models/Modal'
import { Input } from 'src/components/Forms'

interface SaveModalProps {
  isOpen: boolean
  toggle: () => void
  onSave: (title: string) => Promise<void>
  initialTitle?: string
  mode: 'create' | 'copy' | 'update'
}

const validationSchema = Yup.object().shape({
  title: Yup.string().required().label('Report Title')
})

const SaveModal: React.FC<SaveModalProps> = ({ isOpen, toggle, onSave, initialTitle, mode }) => {
  const modalTitle = mode === 'copy' ? 'Save a Copy' : 'Save Report'
  return (
    <Modal isOpen={isOpen} toggle={toggle} title={modalTitle}>
      <Header title={modalTitle} />
      <Formik
        initialValues={{ title: initialTitle ?? '' }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={async ({ title }, { resetForm }) => {
          await onSave(title.trim())
          resetForm()
        }}
      >
        {({ handleSubmit, isSubmitting }) => (
          <>
            <Body error={{ error: '', show: false }}>
              <Input type='text' name='title' label='Report Title' required />
            </Body>
            <Footer
              toggle={toggle}
              action={{
                text: mode === 'copy' ? 'Save a Copy' : 'Save',
                icon: isSubmitting ? faSpinner : faSave,
                color: 'primary',
                disabled: isSubmitting,
                onAction: handleSubmit
              }}
            />
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default SaveModal
